import { Input } from "@sablier/v2-components/organisms";
import { DEFAULT_DECIMALS } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFieldAmount, useFieldToken } from "../logic";

function Token() {
  const { token, onChange } = useFieldToken();
  const { t } = useT();

  return (
    <Input.TokenPicker
      id={token.field.id}
      onChange={onChange}
      label={{ value: _.capitalize(t("words.token")) }}
      placeholder={t("form.placeholder.token")}
      value={{ raw: token.field.value }}
      warning={token.field.warning}
    />
  );
}

function Amount() {
  const { amount, token } = useFieldAmount();
  const { t } = useT();

  return (
    <Input.Amount
      id={amount.field.id}
      decimals={token.field.value?.decimals || DEFAULT_DECIMALS}
      isLoading={amount.field.isLoading}
      label={{ value: t("words.amount") }}
      placeholder={t("form.placeholder.balance")}
      token={token.field.value}
      value={amount.field.value}
      warning={amount.field.warning}
      isPreview
    />
  );
}

const Fields = {
  Amount,
  Token,
};

export default Fields;
